<template>
  <div>
    <el-drawer
      title="唯格云产品型号选择器"
      :visible.sync="showDrawer"
      direction="btt"
      size="90%"
      append-to-body
      @closed="onClose"
    >
      <div class="main-container" ref="mainContainer">
        <div class="filter-row">
          <el-button size="small" icon="el-icon-search" @click="handleSearch"
            >刷新</el-button
          >
          &nbsp;
          <el-input
            placeholder="请输入产品中文名称"
            v-model="currentQuery.productNameCn"
            class="input-title"
            @change="handleSearch"
            clearable
            @clear="handleSearch"
            size="small"
          >
            <el-button slot="prepend" icon="el-icon-search"></el-button>
          </el-input>
        </div>
        <div class="table-container" ref="tableContainer">
          <el-table
            class="base-table"
            :data="tableData"
            border
            :style="tableStyle"
            :size="tableSize"
            :height="tableHeight"
            header-cell-class-name="baseTableHeadStyle"
            ref="multipleTable"
            row-class-name="customs-table-row"
            v-loading="tableLoading"
            element-loading-text="查询中..."
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
              align="center"
              fixed="left"
            />
            <el-table-column type="index" align="center" width="50" />
            <template v-for="column in tableColumns">
              <el-table-column
                v-if="column.showColumn"
                v-bind="column"
                :show-overflow-tooltip="true"
                :key="column.prop"
              >
                <template slot-scope="scope">
                  <span v-if="column.prop === 'nameCn'">
                    <h3>{{ scope.row.nameCn }}</h3>
                    <div>{{ scope.row.nameEn }}</div>
                  </span>
                  <span v-else-if="column.prop === 'disabled'">
                    <el-tag :type="scope.row.disabled ? 'danger' : 'success'">{{
                      scope.row.disabled ? "已禁用" : "已启用"
                    }}</el-tag>
                  </span>
                  <el-image
                    v-else-if="column.prop === 'thumbnailUrl'"
                    style="width: 66px; height: 66px;"
                    :src="scope.row.thumbnailUrl"
                    :preview-src-list="[scope.row.thumbnailUrl]"
                  >
                  </el-image>
                  <el-image
                    v-else-if="column.prop === 'cover_image_url'"
                    style="width: 66px; height: 66px;"
                    :src="scope.row.cover_image_url"
                    :preview-src-list="[scope.row.cover_image_url]"
                  >
                  </el-image>

                  <span v-else>{{ scope.row[column.prop] }}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>
        <div class="custom-table-footer">
          <el-pagination
            class="base-table-pagination"
            :disabled="tableLoading"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
            :current-page="page + 1"
            :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
            :page-size="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
          <el-button
            class="mt-r"
            size="small"
            type="primary"
            icon="el-icon-circle-check"
            @click="handleConfrim"
            >确定 {{ selections.length }}</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { ShowApiError } from "@/request/error";
import { GetProductModelList } from "../api/viewgres_v4";
import vgcColumn from "../mixins/vgcColumn";
import form from "../mixins/form";
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    query: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  mixins: [form, vgcColumn],
  data() {
    return {
      tableStyle: {
        width: "100%",
        height: "100%"
      },
      tableHeight: "500px",
      tableSize: "medium",
      tableLoading: false,
      isMultiple: false,
      tableColumns: [],
      page: 0,
      size: 20,
      total: 0,
      tableData: [],
      orderProp: "postAt",
      orderDirection: "descending",
      currentQuery: {
        productNameCn: ""
      },
      selections: [],
      showDrawer: false
    };
  },
  watch: {
    multiple: {
      handler(value) {
        this.isMultiple = value;
      },
      immediate: true
    },
    query: {
      handler(value) {
        if (Object.keys(value).length > 0) {
          this.currentQuery = { ...value, productNameCn: "" };
        }
      },
      immediate: true,
      deep: true
    },
    show: {
      handler(value) {
        this.showDrawer = value;
        if (this.showDrawer) {
          if (this.tableData.length === 0) {
            this.getTableData();
          }
          if (Object.keys(this.currentQuery).length > 0) {
            this.getTableData();
          }
          this.$nextTick(() => {
            this.tableHeight = `${this.$refs["tableContainer"].clientHeight}px`;
            // console.dir(this.$refs["tableContainer"].clientHeight);
          });
        }
      },
      immediate: true
    }
  },
  created() {
    this.buildTableColumns();
  },

  methods: {
    handleSizeChange(val) {
      this.page = 0;
      this.size = val;
      this.getTableData();
    },
    handlePageChange(val) {
      this.page = val - 1;
      this.getTableData();
    },

    getTableData() {
      this.tableLoading = true;
      GetProductModelList({
        page: this.page,
        size: this.size,
        sort: `seq,DESC`,
        ...this.currentQuery
      })
        .then(res => {
          let { content, total_elements } = res.data;
          this.tableData = content;

          this.total = total_elements;
          // 加载状态结束
          this.tableLoading = false;
        })
        .catch(err => {
          this.tableLoading = false;

          ShowApiError(err, "拉取列表错误");
        });
    },
    handleSearch() {
      this.page = 0;
      this.getTableData();
    },
    handleSelectionChange(data) {
      if (this.isMultiple) {
        this.selections = data;
      } else {
        if (data.length > 0) {
          this.selections = data.slice(0, 1);
        }
      }
    },
    handleConfrim() {
      this.$emit("change", this.selections);
    },
    onClose() {
      this.showDrawer = false;
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.main-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .table-container {
    box-sizing: border-box;
    flex: 1 0 0;
    padding: 0 24px;
    overflow: hidden;
  }
  .base-table {
    width: 100%;
    height: 100%;
  }
}

.custom-table-footer {
  flex: 56px 0 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 12px;
}
.input-title {
  width: 250px;
}
.filter-row {
  width: 100%;
  margin-bottom: 12px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}
</style>
